/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { GetExchangeApplicationInformationByUserUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetExchangeApplicationInformationByUserUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { GetExchangeApplicationInformationByUserUuidOkDto } from '../../src/model';
// @ts-ignore
import type { GetInformationInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetInformationNotFoundDto } from '../../src/model';
// @ts-ignore
import type { GetInformationOkDto } from '../../src/model';
// @ts-ignore
import type { GetUserByUserUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetUserByUserUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { GetUserByUserUuidOkDto } from '../../src/model';
// @ts-ignore
import type { JwtAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { PatchInformationInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PatchInformationNicknameConflictDto } from '../../src/model';
// @ts-ignore
import type { PatchInformationOkDto } from '../../src/model';
// @ts-ignore
import type { PatchInformationReqBodyDto } from '../../src/model';
// @ts-ignore
import type { PostPresignedUrlInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PostPresignedUrlNotFoundDto } from '../../src/model';
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 환급 신청 정보 가져오기
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetExchangeApplicationInformation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/exchange-application-information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 내 정보 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetInformation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 메인페이지 및 상단 아이콘 유저 정보 가져오기
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetUserByUserUuid: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 내 정보 수정
         * @param {PatchInformationReqBodyDto} patchInformationReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerPatchInformation: async (patchInformationReqBodyDto: PatchInformationReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patchInformationReqBodyDto' is not null or undefined
            assertParamExists('userControllerPatchInformation', 'patchInformationReqBodyDto', patchInformationReqBodyDto)
            const localVarPath = `/users/information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchInformationReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 환급 신청 정보 가져오기
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetExchangeApplicationInformation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExchangeApplicationInformationByUserUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetExchangeApplicationInformation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.userControllerGetExchangeApplicationInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 내 정보 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetInformation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInformationOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetInformation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.userControllerGetInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 메인페이지 및 상단 아이콘 유저 정보 가져오기
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetUserByUserUuid(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserByUserUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetUserByUserUuid(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.userControllerGetUserByUserUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 내 정보 수정
         * @param {PatchInformationReqBodyDto} patchInformationReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerPatchInformation(patchInformationReqBodyDto: PatchInformationReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchInformationOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerPatchInformation(patchInformationReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.userControllerPatchInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary 환급 신청 정보 가져오기
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetExchangeApplicationInformation(options?: RawAxiosRequestConfig): AxiosPromise<GetExchangeApplicationInformationByUserUuidOkDto> {
            return localVarFp.userControllerGetExchangeApplicationInformation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 내 정보 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetInformation(options?: RawAxiosRequestConfig): AxiosPromise<GetInformationOkDto> {
            return localVarFp.userControllerGetInformation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 메인페이지 및 상단 아이콘 유저 정보 가져오기
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetUserByUserUuid(options?: RawAxiosRequestConfig): AxiosPromise<GetUserByUserUuidOkDto> {
            return localVarFp.userControllerGetUserByUserUuid(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 내 정보 수정
         * @param {UsersApiUserControllerPatchInformationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerPatchInformation(requestParameters: UsersApiUserControllerPatchInformationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchInformationOkDto> {
            return localVarFp.userControllerPatchInformation(requestParameters.patchInformationReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for userControllerPatchInformation operation in UsersApi.
 * @export
 * @interface UsersApiUserControllerPatchInformationRequest
 */
export interface UsersApiUserControllerPatchInformationRequest {
    /**
     * 
     * @type {PatchInformationReqBodyDto}
     * @memberof UsersApiUserControllerPatchInformation
     */
    readonly patchInformationReqBodyDto: PatchInformationReqBodyDto
}

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary 환급 신청 정보 가져오기
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerGetExchangeApplicationInformation(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerGetExchangeApplicationInformation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 내 정보 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerGetInformation(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerGetInformation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 메인페이지 및 상단 아이콘 유저 정보 가져오기
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerGetUserByUserUuid(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerGetUserByUserUuid(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 내 정보 수정
     * @param {UsersApiUserControllerPatchInformationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerPatchInformation(requestParameters: UsersApiUserControllerPatchInformationRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerPatchInformation(requestParameters.patchInformationReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

